import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_hdr_RowClass, bl_wf_issue_hdr_RowInterface} from '../../../dbschema/bl_wf_issue_hdr.model';
import {bl_wf_issue_ext_RowClass} from '../../../dbschema/bl_wf_issue_ext.model';

export class WfInquiriesContainerModel extends BaseContainerModel {
  bl_wf_issue_hdr: bl_wf_issue_hdr_RowInterface = new bl_wf_issue_hdr_RowClass();

}
